import { render, staticRenderFns } from "./import-grid-footer.vue?vue&type=template&id=17f43a4d&"
import script from "./import-grid-footer.vue?vue&type=script&lang=ts&"
export * from "./import-grid-footer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VRow})
